import React from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useLanguage } from "../../../contexts/LanguageContext";

const ExternalVehicleForm = ({
  dialogVisible,
  editMode,
  submitted,
  hideDialog,
  renderDialogFooter,

  brand,
  model,
  chassisNo,
  licensePlate,

  setBrand,
  setModel,
  setChassisNo,
  setLicensePlate
}) => {
  const { th } = useLanguage();

  return (
    <Dialog
      visible={dialogVisible}
      style={{ width: "580px" }}
      header={editMode ? th("externalVehicle.edit") : th("externalVehicle.new")}
      modal
      className="p-fluid"
      footer={renderDialogFooter()}
      onHide={hideDialog}
    >
      <div className="grid">
        {/* Brand - Zorunlu */}
        <div className="col-12">
          <div className="field mb-4">
            <label className="font-bold block mb-2">
              {th("externalVehicle.brand")} <span className="text-red-500">*</span>
            </label>
            <InputText
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              className={submitted && !brand.trim() ? "p-invalid" : ""}
              placeholder={th("externalVehicle.brandPlaceholder")}
            />
            {submitted && !brand.trim() && (
              <small className="p-error">{th("externalVehicle.brandRequired")}</small>
            )}
          </div>
        </div>

        {/* Model - Zorunlu */}
        <div className="col-12">
          <div className="field mb-4">
            <label className="font-bold block mb-2">
              {th("externalVehicle.model")} <span className="text-red-500">*</span>
            </label>
            <InputText
              value={model}
              onChange={(e) => setModel(e.target.value)}
              className={submitted && !model.trim() ? "p-invalid" : ""}
              placeholder={th("externalVehicle.modelPlaceholder")}
            />
            {submitted && !model.trim() && (
              <small className="p-error">{th("externalVehicle.modelRequired")}</small>
            )}
          </div>
        </div>

        {/* ChassisNo - Zorunlu */}
        <div className="col-12">
          <div className="field mb-4">
            <label className="font-bold block mb-2">
              {th("externalVehicle.chassisNo")} <span className="text-red-500">*</span>
            </label>
            <InputText
              value={chassisNo}
              onChange={(e) => setChassisNo(e.target.value)}
              className={submitted && !chassisNo.trim() ? "p-invalid" : ""}
              placeholder={th("externalVehicle.chassisNoPlaceholder")}
            />
            {submitted && !chassisNo.trim() && (
              <small className="p-error">{th("externalVehicle.chassisNoRequired")}</small>
            )}
          </div>
        </div>

        {/* LicensePlate - Opsiyonel */}
        <div className="col-12">
          <div className="field mb-4">
            <label className="font-bold block mb-2">
              {th("externalVehicle.licensePlate")}
            </label>
            <InputText
              value={licensePlate}
              onChange={(e) => setLicensePlate(e.target.value)}
              placeholder={th("externalVehicle.licensePlatePlaceholder")}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ExternalVehicleForm;
